import type { ButtonBaseSize } from '../ButtonBase/constants';
import type { LabelSize } from '../Label/types';
import type { LinkSize } from '../Link';
import type { StatusSize } from '../Status/types';

export const LabelContainerButtonSizeMap: Record<LabelSize, ButtonBaseSize> = {
  sm: 'sm',
  md: 'md',
  lg: 'md',
  xl: 'md',
};

export const LabelContainerLinkSizeMap: Record<LabelSize, LinkSize> = {
  sm: 'xs',
  md: 'sm',
  lg: 'sm',
  xl: 'sm',
};

export const LabelContainerStatusSizeMap: Record<LabelSize, StatusSize> = {
  sm: 'xs',
  md: 'sm',
  lg: 'sm',
  xl: 'sm',
};
